// MUI
import { GridRenderEditCellParams } from "@mui/x-data-grid-premium";

// Types
import { DataRecord } from "@/Layouts/components/InputComponents/types";
import { BasicNumericEditCell } from "./BasicNumericEditCell";

// Helpers
import { convertValueWithInput, getInputsToColumnsAddons, getInputsVariants, getOppositeInput } from "@/Washouts/helpers/Compensation";
import { NumberOrString } from "@/Layouts/components/InputComponents/InputValue/types";

export function NumericTierEditCell(
	params: Readonly<
		GridRenderEditCellParams & { inputTypeVariant: 0 | 1; inputAlternative: string; data: DataRecord[]; onChangeType: () => void }
	>
) {
	const updateCommission = async (api: GridRenderEditCellParams["api"], commission = 0) => {
		await api.setEditCellValue({
			id: params.id,
			field: "commission",
			value: commission,
			debounceMs: 200,
		});
	};

	const handleBlur = async (inputValue: NumberOrString) => {
		const { api, field, inputTypeVariant = 0, inputAlternative = "" } = params;
		const fieldToMultiply = getOppositeInput(field, inputAlternative);

		const current = Number(inputValue);
		const opposite = Number(params.row?.[fieldToMultiply] || 0);

		const validValues = !isNaN(opposite) && !isNaN(current);
		const inputsToUse = getInputsVariants({ field, inputAlternative, inputTypeVariant });

		await api.setEditCellValue({
			id: params.id,
			field: "columnsAddons",
			value: getInputsToColumnsAddons(inputsToUse),
			debounceMs: 200,
		});

		if (validValues) {
			const v1 = convertValueWithInput(current, inputsToUse[field]);
			const v2 = convertValueWithInput(opposite, inputsToUse[fieldToMultiply]);
			const commission = v1 * v2;
			await updateCommission(api, commission);
		}
	};

	return (
		<BasicNumericEditCell
			{...params}
			inputProps={{
				data: params.data || [],
				onBlur: handleBlur,
				acceptsEmptyValues: false,
				inputTypeIndex: params.inputTypeVariant,
				onChangeType: () => {
					params?.onChangeType?.();
					updateCommission(params.api, 0);
				},
			}}
		/>
	);
}
